const o = {
  fontFamily: "sans-serif",
  fontSize: "sm",
  fontWeight: "medium",
  color: "text-secondary",
  marginBottom: "spacing-1,5"
}, r = {
  color: "text-error-primary"
};
export {
  o as label,
  r as labelError
};
